import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import Logo from "@/components/Logo";

const NAV_ITEMS = [
  { label: "About", href: "#about" },
  { label: "Programs", href: "#programs" },
  { label: "Coaches", href: "#coaches" },
  { label: "Gallery", href: "#gallery" },
  { label: "Stories", href: "#testimonials" },
  { label: "Register", href: "#register" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar({ scrolled }) {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-black/60 border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="navbar-logo"
          className="group"
        >
          <Logo size="sm" />
        </a>

        <nav className="hidden lg:flex items-center gap-7 xl:gap-9">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.href}
              href={item.href}
              data-testid={`nav-link-${item.label.toLowerCase()}`}
              className="text-sm uppercase tracking-widest text-white/70 hover:text-red-600 transition-colors"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex">
          <Button
            asChild
            data-testid="navbar-cta-button"
            className="bg-red-600 hover:bg-red-500 text-white font-heading uppercase tracking-widest rounded-full px-6"
          >
            <a href="#register">Enroll Now</a>
          </Button>
        </div>

        <button
          data-testid="navbar-mobile-toggle"
          onClick={() => setOpen((s) => !s)}
          className="lg:hidden text-white p-2 rounded-md hover:bg-white/10"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div
          data-testid="navbar-mobile-menu"
          className="lg:hidden border-t border-white/10 bg-black/95 backdrop-blur-xl"
        >
          <div className="px-6 py-6 flex flex-col gap-5">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                data-testid={`nav-link-mobile-${item.label.toLowerCase()}`}
                className="text-base uppercase tracking-widest text-white/80 hover:text-red-600"
              >
                {item.label}
              </a>
            ))}
            <Button
              asChild
              data-testid="navbar-cta-button-mobile"
              className="bg-red-600 hover:bg-red-500 text-white font-heading uppercase tracking-widest rounded-full"
            >
              <a href="#register" onClick={() => setOpen(false)}>
                Enroll Now
              </a>
            </Button>
          </div>
        </div>
      )}
    </header>
  );
}
